<template>
  <div class="wrap">
    <img src="@imgs/401.png" v-if="code == 401" />
    <!-- <img src="@imgs/404.png" v-if="code === 404" /> -->
  </div>
</template>
<script>
export default {
  name: 'None',
  data() {
    return {
      code: 401
    }
  },
  created() {
    console.log(typeof this.$route.params.code)
    this.code = this.$route.params.code || 401
  }
}
</script>
<style scoped lang="scss">
.wrap {
  width: 100%;
  text-align: center;
  img {
    margin-top: 100px;
    vertical-align: middle;
  }
}
</style>
